export default "__VITE_ASSET__Cl64Jh68__"